// extracted by mini-css-extract-plugin
module.exports = {"result_block__title":"styles_result_block__title__JX1Wa","refresh_button":"styles_refresh_button__1OBsA","close_button_container":"styles_close_button_container__1rZL0"};